import classNames from 'classnames'
import React from 'react'
import { Spinner } from 'reactstrap'

import './Loading.css'

const Loading = ({ isImage, size }) => {
   return (
      <div className={classNames("loading", "text-center", {
         "loading--img": isImage,
         ["loading--" + size]: size,
      })}>
         <Spinner />
      </div >
   )
}

export default Loading
